// extracted by mini-css-extract-plugin
export default {"icon--medium":"M0T5KMA","icon--small":"Px_FLN9"};